import { Fragment, useContext } from "react";
import styled from "styled-components";
import LinkButton from "common/Buttons/LinkButton";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import usePracticeExchange from "features/onboarding/guided/usePracticeExchange";
import { ONBOARDING_CHANGE_PRACTICE_ID } from "testIds";

/**
 * The walkthrough's one quiet meta line: "Demo · Binance Futures · Change"
 * (plus the example's pair when there is one), or "Live setup".
 */
const WalkthroughMeta = ({ demo, pair }: { demo: boolean; pair?: string }) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const { t: common } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { changeStep } = useContext(OnboardingContext)!;
  const { exchangeDisplay } = usePracticeExchange();
  if (!demo) return <span>{t("intent.live_setup")}</span>;
  const parts = [
    common("demo_mode.workspace_demo_short"),
    exchangeDisplay,
    ...(pair ? [pair] : []),
  ];
  return (
    <>
      {parts.map((part) => (
        <Fragment key={part}>
          <span>{part}</span>
          <Dot aria-hidden>·</Dot>
        </Fragment>
      ))}
      <LinkButton
        type="link"
        data-testid={ONBOARDING_CHANGE_PRACTICE_ID}
        onClick={() =>
          changeStep(OnboardingDetailedStep.CONNECT_EXCHANGE, {
            guided: "1",
            prepareDemo: "",
            changePractice: "1",
          })
        }
      >
        {t("walkthrough.change")}
      </LinkButton>
    </>
  );
};

export default WalkthroughMeta;

const Dot = styled.span`
  color: ${(p) => p.theme.colors.secondaryText};
  opacity: 0.6;
`;
